<div id="contract-ttl" class="card">
    <div class="card-body">
        <form [formGroup]="form">
            @if (outsideOrCash) {
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="outOfState" formControlName="outOfState" switch="true" />
                    <label class="form-check-label" for="outOfState">Out of State?</label>
                </div>
            }
            <ng-container formArrayName="fees">
                <ul>
                    @for (feeForm of fees.controls; track feeForm; let i = $index) {
                        @if (!outOfState || (feeForm.get('sticky').value)) {
                            <li [formGroup]="feeForm">
                                <label for="staf-custom-{{i}}" class="col-form-label">{{feeForm.get('name').value}}</label>
                                @if (!feeForm.get('formula').value) {
                                    <currency-input [id]="'staf-custom-' + i" [control]="feeForm.get('custom')" (committed)="changed($event)" (blurred)="changed($event)"></currency-input>
                                }
                                @else {
                                    <percent-input [id]="'staf-custom-' + i" [control]="feeForm.get('custom')" [prepend]="'$' + feeForm.get('amount').value" (committed)="changed($event)" (blurred)="changed($event)"></percent-input>
                                }
                                <div class="actions d-flex flex-nowrap justify-content-between">
                                    @if ((!form.get('outOfState').value) && feeForm.get('custom').dirty && isUnLock) {
                                        <button title="Restore" class="btn btn-sm btn-link" (click)="restore(i)"><span class="dripicons dripicons-clockwise text-primary"></span></button>
                                    }
                                    @if (feeForm.get('category').value == 'Inventory Tax') {
                                        <div class="d-flex" [formGroup]="form">
                                            <small for="inventoryTaxType" class="col-4 form-control-sm form-control-plaintext text-nowrap">Tax Type</small>
                                            <div class="col-8">
                                                <select class="form-control form-control-sm text-dark" formControlName="inventoryTaxType">
                                                    @for (taxType of taxTypes; track taxType) {
                                                        <option [value]="taxType.value">{{taxType.value}}</option>
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </li>
                        }
                        
                    }
                    @empty {
                        <li><p class="alert alert-secondary"><strong>{{saleTypes[saleType]}}</strong> sales do not have any fees.</p></li>
                    }
                    <li class="totals">
                        <p class="text-left"></p>
                        <p class="text-right">{{total | currency}}</p>
                        <p></p>
                    </li>
                </ul>
            </ng-container>
        </form>
    </div>
</div>